import { render, staticRenderFns } from "./Aggregates.vue?vue&type=template&id=c2ae5eea&scoped=true&"
import script from "./Aggregates.vue?vue&type=script&lang=js&"
export * from "./Aggregates.vue?vue&type=script&lang=js&"
import style0 from "./Aggregates.vue?vue&type=style&index=0&id=c2ae5eea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ae5eea",
  null
  
)

export default component.exports